{
  "aboutCluster": "About Cluster",
  "accountSettings": "Account Settings",
  "addEvent": "Add event",
  "addMeeting": "Add meeting",
  "advisors": "Advisors",
  "boardGroup": "Board Group",
  "businessDescription": "Business description",
  "clusterManagement": "Cluster Management",
  "companyInformation": "Company information",
  "contactDetails": "Contact details",
  "contactInformation": "Contact information",
  "contacts": "Contacts",
  "economyEsaReporting": "Economy/ESA reporting",
  "fastContactRegistration": "Quick contact registration",
  "fastDeductibleRegistration": "Quick deductible registration",
  "fastInKindRegistration": "Quick in kind registration",
  "fastMemberRegistration": "Quick member registration",
  "focusAreas": "Focus Areas",
  "grunndata": "Core Data",
  "inkindOverview": "In kind overview",
  "interestAreas": "Interest Areas",
  "mainGoals": "Mail Goals",
  "memberContribution": "Member contribution and in kind",
  "memberInformation": "Member information",
  "membershipFees": "Membership fees",
  "projectCategories": "Project categories",
  "registerDeductible": "Register deductible",
  "timeRates": "Time Rates",
  "visionMission": "Vision and Mission",
  "yourProfile": "Your profile",
  "accessControl": "Access control"
}
